var _defs, _g, _path, _polyline, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPulsecaremdIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    width: 80,
    height: 80,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "PulsecareMD") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heart-mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 70 C 18 56, 6 42, 6 28 C 6 16, 15 8, 26 8 C 32 8, 37 11, 40 16 C 43 11, 48 8, 54 8 C 65 8, 74 16, 74 28 C 74 42, 62 56, 40 70 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heart-mask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 55,
    width: 80,
    height: 25,
    fill: "#F58220"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 70 C 18 56, 6 42, 6 28 C 6 16, 15 8, 26 8 C 32 8, 37 11, 40 16 C 43 11, 48 8, 54 8 C 65 8, 74 16, 74 28 C 74 42, 62 56, 40 70 Z",
    fill: "none",
    stroke: "#1E2C5D",
    strokeWidth: 4.5,
    strokeLinejoin: "round"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "10,36 22,36 28,24 34,48 40,32 48,36 60,36",
    fill: "none",
    stroke: "#1E2C5D",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 36,
    r: 3,
    fill: "#1E2C5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPulsecaremdIcon);
export default __webpack_public_path__ + "static/media/pulsecaremd-icon.ad6393dfaad7c2056f63be59770ded96.svg";
export { ForwardRef as ReactComponent };